
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punesadeteenshaktipeethbusonrent() {



  const cardData =
  {
    keyword: ' Pune Sade Teen Shakti Peeth Bus on Rent',
    heading: 'Vaishnavi Travels: Pune Sade Teen Shakti Peeth Bus on Rent',
    headingDescription: 'Vaishnavi Travels offers convenient and affordable Pune Sade Teen Shakti Peeth Bus on Rent, ideal for pilgrims, families, and groups planning a sacred journey. Our buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage space to ensure a smooth and comfortable ride to the holy Shakti Peeth temples. With professional drivers, punctual service, and flexible booking options, we make religious travel stress-free and reliable. Whether it’s a one-day pilgrimage or an extended yatra, Vaishnavi Travels guarantees safe, comfortable, and dependable bus rental services for visiting the Sade Teen Shakti Peeth from Pune.',

    top: 'Top Places to Visit in Sade Teen Shakti Peeth with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Tulja Bhavani Temple, Tuljapur",
    "description": "Tulja Bhavani Temple in Tuljapur, Osmanabad district, is one of the Sade Teen Shakti Peethas of Maharashtra. Dedicated to Goddess Bhavani, it is believed that Chhatrapati Shivaji Maharaj received his sword ‘Bhavani Talwar’ here, adding to its historical significance. The temple’s black stone idol is adorned with gold ornaments, flowers, and vibrant decorations. Navratri and Dasara festivals attract lakhs of devotees who arrive in grand yatras. The temple complex includes holy tanks like Gomukh Tirtha, adding to the spiritual aura. Tulja Bhavani Temple is Maharashtra’s living symbol of faith, power, and heritage."
  },
  {
    "title": "Mahalaxmi Temple, Kolhapur",
    "description": "Mahalaxmi Temple, also called Ambabai Temple, is one of the four main Shakti Peethas in India and an integral part of the Sade Teen Shakti Peeth. Built in the 7th century by the Chalukyas, it is dedicated to Goddess Mahalaxmi, the goddess of wealth and prosperity. The temple features exquisite stone carvings, a black stone idol, and a beautiful sanctum. Pilgrims visit in huge numbers during Kirnotsav when sunrays directly fall on the goddess’s idol. The temple town of Kolhapur also bustles with cultural activities and vibrant markets. Mahalaxmi Temple is the spiritual jewel of Kolhapur and a must-visit Shakti Peeth."
  },
  {
    "title": "Renuka Devi Temple, Mahur",
    "description": "Located in Nanded district, Renuka Devi Temple in Mahur is another sacred site among the Sade Teen Shakti Peeths. Dedicated to Goddess Renuka, mother of Lord Parshuram, the temple sits atop a hill surrounded by forests. Pilgrims climb stone steps or take vehicles to reach the shrine, where the goddess is worshipped in her ancient form. Navratri is celebrated here with great devotion and cultural festivities. The temple is also associated with mythological legends from the Puranas. Renuka Devi Temple is Maharashtra’s serene and divine pilgrimage spot in the Shakti Peeth circuit."
  },
  {
    "title": "Saptashrungi Devi Temple, Vani (Half Peeth)",
    "description": "Saptashrungi Devi Temple, near Nashik, is considered the ‘half’ Peeth in the Sade Teen Shakti Peeth yatra. Perched on a hill with 510 steps leading up, it is surrounded by seven mountain peaks (Saptashrungi), which give it its name. The goddess idol is carved into a rock and is said to have appeared naturally. Pilgrims believe the goddess fulfills wishes and protects devotees from evil. Navratri and Chaitra festivals witness huge crowds here. The panoramic mountain views add natural beauty to the spiritual journey. Saptashrungi is Maharashtra’s half Shakti Peeth, completing the revered pilgrimage circuit."
  }
],

"services": [
  {
    "name": "Sade Teen Shakti Peeth Tour Bus",
    "description": "Comprehensive pilgrimage tour bus services from Pune covering the Sade Teen Shaktipeeth temples—Mahalaxmi Kolhapur, Tulajabhavani Tuljapur, Renuka Mata Mahurgad, and the half‑Shaktipeeth Saptashringi Vani. The journey is organized over multiple days with comfortable overnight stays, clean and sanitized AC/non‑AC buses, and meals arranged on the route. It includes experienced drivers familiar with pilgrimage timing and temple darshans, rest stops, and managing local traffic and timings for rituals and festivals. A spiritually enriching, hassle‑free package for devotees who wish to cover all four in one journey with safety and comfort."
  },
  {
    "name": "Shaktipeeth Yatra Bus from Pune",
    "description": "Scheduled Yatra buses starting from Pune for devotees wanting to perform the Shaktipeeth pilgrimage. These buses are equipped with reclining seats, AC options for hot weather, and driver teams that understand early starts and night travel. The service often includes optional guide / announcements about the mythological significance of each temple, planned halts for meals and rest, and coordination for temple darshan windows. Ideal for individuals, groups, or mandals making the journey over 3‑5 days."
  },
  {
    "name": "Religious Tour Bus Pune",
    "description": "Religious‑oriented bus tours originating from Pune that include itineraries for visiting Shaktipeeths and nearby holy sites. These buses focus on spiritual comfort—quiet spaces, devotional music, rest breaks timed for rituals, and coordination with temple authorities. Vehicles are maintained to ensure smooth road travel across rural and hilly routes, with backup options in case of schedule changes or delays due to traffic or temple timings."
  },
  {
    "name": "AC Bus for Shakti Peeth Trip",
    "description": "Air‑conditioned buses dedicated to Shaktipeeth pilgrimage trips departing from Pune, offering enhanced comfort during long road stretches and in warmer seasons. Features include cushioned reclining seats, well‑ventilated interiors, clean restrooms (if available), charging points, and optional refreshments. Ideal for senior devotees and those preferring more comfort on their spiritual journey. AC buses also help in maintaining calm and restful travel between temples."
  },
  {
    "name": "Non AC Shakti Peeth Bus Hire",
    "description": "Economical pilgrimage bus hire options without AC, for groups or individuals who prefer modest pricing. Non‑AC buses still maintain core comfort—good suspension, regular maintenance, reliable drivers, rest stops, and safety features—while reducing cost. Suitable in cooler months or for short segments between villages/traditional routes when AC isn’t necessary."
  },
  {
    "name": "Group Tour to Sade Teen Shakti Peeth",
    "description": "Organized group tours from Pune with larger buses (30‑50 seaters or more depending on group size), special group rates, group coordination services. Designed for mandals, religious societies, school/youth groups. These tours include coordinated pickups, group darshan tickets if needed, shared lodging, group meals, and an itinerary that balances travel and rest. Drivers and organizers often managed to ensure group safety and cohesion during the journey."
  },
  {
    "name": "40 Seater Religious Bus Pune",
    "description": "40‑seater buses reserved specifically for religious pilgrimages like the Shaktipeeth circuit. These offer ample space for pilgrims, luggage (offerings etc.), and comfortable interiors. With AC / non‑AC variants, experienced drivers, insurance, and scheduling that accommodates temple timetables and major festival days like Navratri, ensuring devotees reach temples in the best possible windows for darshan."
  },
  {
    "name": "Pilgrimage Tour Bus Pune",
    "description": "Full pilgrimage tour bus packages from Pune including the Shaktipeeths, often extending to other devotional sites. These tours come as packaged‑deals—bus travel, food, lodging, guide services, sometimes even local transportation near remote temple sites. The emphasis is on spiritual immersion, comfort, safety, and minimizing the logistical concerns for pilgrims so that they can focus on the darshan and spiritual experience."
  },
  {
    "name": "Pune Temple Tour Bus Rental",
    "description": "Shorter temple‑tour bus rentals from Pune that may cover one or two Shaktipeeths or other famous temples in the region. Ideal for those who cannot spare many days but wish to visit sacred sites. These rentals include schedule customization, timely returning to accommodate usual commitments, clean buses, courteous drivers, and optional AC to suit weather and passenger needs."
  },
  {
    "name": "Spiritual Trip Bus Hire Pune",
    "description": "Customized spiritual trips arranged by bus from Pune, including Shaktipeeths and other pilgrimage centers. These include services like devotional music onboard, early morning departures, rest stops suitable for elders, dietary considerations (if requested), coordination with temple darshan times, and comfortable overnight stays. Designed to make spiritual travel more accessible, especially for first‑time pilgrims."
  },
  {
    "name": "Sade Teen Shakti Bus Booking Pune",
    "description": "Easy booking service from Pune for buses destined for Shaktipeeth pilgrimage. Offers transparent pricing, multiple seat category options (AC / non‑AC, group / individual), advance booking especially during festivals, cancellation policies, and support with route details. Designed to remove uncertainty for devotees about bus availability especially when demand is high during auspicious periods. (For example, special MSRTC buses are arranged around Navratri for ‘साडेतीन शक्तिपीठ दर्शन’). :contentReference[oaicite:0]{index=0}"
  },
  {
    "name": "Luxury Bus for Shakti Yatra",
    "description": "High‑end luxury buses for devotees looking for premium pilgrimage travel. These vehicles include reclining plush seats, strict hygiene standards, possibly onboard refreshments or basic food, AC throughout, possibly entertainment, clean washrooms (if possible), and courteous service. Ideal for those wanting both spiritual fulfillment and travel comfort during the multi‑day Yatra."
  },
  {
    "name": "Pune Religious Sites Bus Hire",
    "description": "Bus hire services from Pune that cover religious sites beyond the Shaktipeeths—temples, holy towns, pilgrim circuits. Tailored itineraries can be made combining multiple temples in a single trip. With services including guide or commentary, scheduled stops, safe routes, driver familiarity with remote temple access, overnight halts, and flexibility for festival‑related travel surges."
  }
],
"tableData": [
  ["Sade Teen Shakti Peeth Tour Bus", "Shaktipeeth Yatra Bus from Pune"],
  ["Religious Tour Bus Pune", "AC Bus for Shakti Peeth Trip"],
  ["Non AC Shakti Peeth Bus Hire", "Group Tour to Sade Teen Shakti Peeth"],
  ["40 Seater Religious Bus Pune", "Pilgrimage Tour Bus Pune"],
  ["Pune Temple Tour Bus Rental", "Spiritual Trip Bus Hire Pune"],
  ["Sade Teen Shakti Bus Booking Pune", "Luxury Bus for Shakti Yatra"],
  ["Pune Religious Sites Bus Hire"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Sade Teen Shakti Peeth Bus on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers trusted bus rental services from Pune to Sade Teen Shakti Peeth, ideal for pilgrimage and group travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and comfortable seats to ensure a pleasant journey to Sade Teen Shakti Peeth."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is regularly serviced and thoroughly cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Pilgrimage Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel plans and group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, punctual, and courteous service with expert knowledge of the Pune to Sade Teen Shakti Peeth route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Religious Tours, Group Travel, and Events",
    "WhyChoosedescription": "Perfect for pilgrimage tours, group outings, and special events involving travel to Sade Teen Shakti Peeth."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock customer assistance to help with bookings, itinerary changes, and travel inquiries."
  }
]

























  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer bus rental services from Pune to Sade Teen Shakti Peeth?',
      answer: 'Yes, Vaishnavi Travels provides comfortable and reliable bus rental services from Pune to Sade Teen Shakti Peeth, ideal for religious tours, group pilgrimages, and spiritual visits.',
    },
    {
      question: 'What types of buses are available for Pune to Sade Teen Shakti Peeth trips?',
      answer: 'We offer a variety of buses including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, suitable for different group sizes and comfort levels.',
    },
    {
      question: 'What is the approximate cost for hiring a bus from Pune to Sade Teen Shakti Peeth?',
      answer: 'The cost typically starts from ₹7,500 for a one-day trip with a 32 seater tempo traveller. Pricing varies based on bus type, trip duration, and amenities, with custom quotes provided.',
    },
    {
      question: 'Are drivers included in the rental service?',
      answer: 'Yes, all rentals include experienced and licensed drivers familiar with the Pune to Sade Teen Shakti Peeth route, ensuring safe and smooth travel.',
    },
    {
      question: 'Can the itinerary be customized for the trip?',
      answer: 'Absolutely. We tailor the itinerary, stops, and timing according to your group’s preferences and schedule.',
    },
    {
      question: 'How far in advance should I book the bus?',
      answer: 'Booking 2-4 days in advance is advisable, especially during festivals and peak pilgrimage seasons, to ensure availability.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the rental fare?',
      answer: 'Tolls, parking fees, driver allowances, and permits are generally extra and will be transparently communicated in your quote.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rohit Joshi",
    position: "Spiritual Group Leader",
    feedback:
      "Vaishnavi Travels provided excellent service for our Pune to Sade Teen Shakti Peeth pilgrimage. The bus was clean, comfortable, and the driver was professional and courteous throughout the journey.",
    rating: 5,
  },
  {
    name: "Mrs. Anjali Patil",
    position: "Group Organizer",
    feedback:
      "We booked a 40 seater AC bus for our spiritual trip to Sade Teen Shakti Peeth. The experience was wonderful – the bus was well-maintained and the driver ensured a smooth, safe trip. Highly recommend Vaishnavi Travels!",
    rating: 5,
    style: "style-2",
  }
];

























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Sade Teen Shakti Peeth Bus on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-sade-teen-shakti-peeth-bus.jpg",
  "description": "Book Pune Sade Teen Shakti Peeth bus on rent with Vaishnavi Travels for comfortable AC and Non AC buses perfect for religious tours, spiritual trips, and group pilgrimages.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.79",
    "ratingCount": "940"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-sade-teen-shakti-peeth-bus-on-rent"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune Sade Teen Shakti Peeth Bus on Rent | Religious & Spiritual Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune Sade Teen Shakti Peeth bus on rent with Vaishnavi Travels for comfortable AC and Non AC buses perfect for religious tours, spiritual trips, and group pilgrimages."
  />
  <meta
    name="keywords"
    content="Sade Teen Shakti Peeth Tour Bus, Shaktipeeth Yatra Bus from Pune, Religious Tour Bus Pune, AC Bus for Shakti Peeth Trip, Non AC Shakti Peeth Bus Hire, Group Tour to Sade Teen Shakti Peeth, 40 Seater Religious Bus Pune, Pilgrimage Tour Bus Pune, Pune Temple Tour Bus Rental, Spiritual Trip Bus Hire Pune, Sade Teen Shakti Bus Booking Pune, Luxury Bus for Shakti Yatra, Pune Religious Sites Bus Hire"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punesadeteenshaktipeethbusonrent;